/**
 * Device ID utility for user privacy
 * Generates a unique device identifier stored in localStorage
 * This ensures users only see their own conversations without requiring authentication
 */

const DEVICE_ID_KEY = 'nexi_device_id';

/**
 * Get or create a unique device ID for this user
 * @returns {string} The device ID
 */
export const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    // Generate a new unique device ID
    deviceId = 'device_' + crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
};

/**
 * Clear the device ID (useful for testing or "reset" functionality)
 */
export const clearDeviceId = () => {
  localStorage.removeItem(DEVICE_ID_KEY);
};

export default getDeviceId;
